export const name: string = 'About';
export const group = 'Administrative';
export const moduleName: string = 'pdc-widget-about';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-about';
//export const priority: number = 1;
